/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AnswerTypeEnum } from './AnswerTypeEnum';
import { AnswerTypeEnumFromJSON, AnswerTypeEnumFromJSONTyped, AnswerTypeEnumToJSON } from './AnswerTypeEnum';

/**
 *
 * @export
 * @interface Question
 */
export interface Question {
  /**
   *
   * @type {number}
   * @memberof Question
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof Question
   */
  text: string;
  /**
   *
   * @type {number}
   * @memberof Question
   */
  step: number;
  /**
   *
   * @type {number}
   * @memberof Question
   */
  order: number;
  /**
   *
   * @type {boolean}
   * @memberof Question
   */
  isSeverityQuestion: boolean;
  /**
   *
   * @type {AnswerTypeEnum}
   * @memberof Question
   */
  answerType: AnswerTypeEnum;
  /**
   *
   * @type {Array<number>}
   * @memberof Question
   */
  answerOptions?: Array<number>;
  /**
   *
   * @type {string}
   * @memberof Question
   */
  info?: string | null;
}

/**
 * Check if a given object implements the Question interface.
 */
export function instanceOfQuestion(value: object): value is Question {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('text' in value) || value['text'] === undefined) return false;
  if (!('step' in value) || value['step'] === undefined) return false;
  if (!('order' in value) || value['order'] === undefined) return false;
  if (!('isSeverityQuestion' in value) || value['isSeverityQuestion'] === undefined) return false;
  if (!('answerType' in value) || value['answerType'] === undefined) return false;
  return true;
}

export function QuestionFromJSON(json: any): Question {
  return QuestionFromJSONTyped(json, false);
}

export function QuestionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Question {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    text: json['text'],
    step: json['step'],
    order: json['order'],
    isSeverityQuestion: json['is_severity_question'],
    answerType: AnswerTypeEnumFromJSON(json['answer_type']),
    answerOptions: json['answer_options'] == null ? undefined : json['answer_options'],
    info: json['info'] == null ? undefined : json['info'],
  };
}

export function QuestionToJSON(value?: Question | null): any {
  if (value == null) {
    return value;
  }
  return {
    id: value['id'],
    text: value['text'],
    step: value['step'],
    order: value['order'],
    is_severity_question: value['isSeverityQuestion'],
    answer_type: AnswerTypeEnumToJSON(value['answerType']),
    answer_options: value['answerOptions'],
    info: value['info'],
  };
}
